// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"EmergencyMessage__buttonWrapper___1VVic","mobile":"EmergencyMessage__mobile___2pPNF"};